import axios from '../../axios'
import qs from 'qs';

/* 
 * 测试
 */

// 登录
export const test = (data) => {
	data = qs.stringify(data);
	return axios({
		url: '/test.php',
		method: 'post',
		data
	});
}
